import { render, staticRenderFns } from "./h5result.vue?vue&type=template&id=64da26c0&scoped=true"
import script from "./h5result.vue?vue&type=script&lang=js"
export * from "./h5result.vue?vue&type=script&lang=js"
import style0 from "./h5result.vue?vue&type=style&index=0&id=64da26c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da26c0",
  null
  
)

export default component.exports